import { render } from "./Webhook.vue?vue&type=template&id=9961a742"
import script from "./Webhook.vue?vue&type=script&lang=js"
export * from "./Webhook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_typescript@5.9.3__webpack@5.107.2_4de69cea878ee2f242d39cab111b5a83/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__